import { db } from '@/main';

export const namespaced = true

export const state = {
	customers: [],
	customer: {
		id: null,
		name: '',
		email: '',
		phone: '',
		address: '',
		role: 'customer',
		active: true,
		user_uid: '',
		notes: null
	},
	dialog: false,
	editMode: false,
}

export const mutations = {
	SET_CUSTOMER(state, data) {
		state.customer = data
	},
	SET_CUSTOMERS(state, data) {
		state.customers = data
	},
	SET_CUSTOMER_DIALOG: (state, data) => {
		state.dialog = !state.dialog;
		state.editMode = data.editMode;
		state.customer = data.customer;
	},
}

export const actions = {
	getCustomers({ commit, dispatch }) {
		return new Promise(resolve => {
			db.collection('customers').where('role','==','customer').onSnapshot(function (querySnapshot) {
				let customers = [];
				querySnapshot.forEach( (doc) => customers.push(doc.data()) )
				commit('SET_CUSTOMERS', customers);
				dispatch('setLoaded', true, { root: true })
				resolve();
			})
		});
	},
	toggleCustomerDialog({ commit }, data) {
		commit('SET_CUSTOMER_DIALOG', data);
	},
	setCustomer({commit}, data){
		commit('SET_CUSTOMER', data)
	}
}

export const getters = {

	customersDialog: (state) => {
		return state.dialog;
	},
	customerForEdit: (state) => {
		return state.customer;
	},
	customerDialogEditMode: (state) => {
		return state.editMode;
	}

}
